import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar: React.FC = () => {
  const { pathname } = useLocation();

  const isActive = (path: string) => pathname === path;

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-inner">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo-link">
            <img
              src={`${import.meta.env.BASE_URL}logo.svg`}
              alt="PACA Logo"
              className="navbar-logo"
            />
            <span className="navbar-title">
              <span className="title-paleo">Paleo</span>
              <span className="title-coordinates">coordinates</span>
              <span className="title-calculator">Calculator</span>
            </span>
          </Link>
        </div>

        <nav className="navbar-menu">
          <Link to="/" className={isActive("/") ? "nav-link active" : "nav-link"}>
            Home
          </Link>

          <Link
            to="/rotate"
            className={isActive("/rotate") ? "nav-link active" : "nav-link"}
          >
            Rotate
          </Link>

          <Link
            to="/citation"
            className={isActive("/citation") ? "nav-link active" : "nav-link"}
          >
            Citation
          </Link>

          <Link
            to="/about"
            className={isActive("/about") ? "nav-link active" : "nav-link"}
          >
            About
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
